module.exports = __webpack_public_path__ + "images/category_lp/game_console/main-view@2x_0743a1e0e36231cd738af342f93d5531.png";